import React, { useEffect, useState } from "react";
import BaseSwitch from "../Base/BaseSwitch";
import Card from "../Base/Card";
import {
  GetSubscriptionGroup,
  SubscriptionGroup,
} from "../../redux/selfService/selfServiceSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import LoadingSpinner from "../LoadingSpinner";

interface SubscriptionI {
  email: boolean;
  sms: boolean;
}

interface InitialSubscriptionI {
  birthday: SubscriptionI;
  contributionMessage: SubscriptionI;
  promotionalMessage: SubscriptionI;
  eStatement: SubscriptionI;
}

// const initialSubscription :InitialSubscriptionI = {
//     birthday: {
//         email: true,
//         sms: false
//     },
//     contributionMessage: {
//         email: true,
//         sms: false
//     },
//     promotionalMessage: {
//         email: true,
//         sms: true
//     },
//     eStatement: {
//         email: false,
//         sms: true
//     },
// }

const Subscriptions = () => {
  const dispatch = useAppDispatch();
  const { subscriptionGroup, isLoading } = useAppSelector(
    (state) => state?.selfService
  );

  useEffect(() => {
    dispatch(GetSubscriptionGroup());
  }, []);

  return (
    <Card className="bg-grayscaleBG p-8">
      <div className="subscription__head">
        <div className="subscription__head--head">Subscriptions</div>
        <div className="subscription__head--text">
          We may still send you important notifications about your account
          outside of your subscription settings.
        </div>
      </div>
      {subscriptionGroup && (
        <div className="subscription__notification">
          Subscription modifications are not available at the moment due to an
          ongoing approval process.
        </div>
      )}
      <div className="subscription-item">
        {
        !isLoading ? 
        (
          subscriptionGroup.length > 0 &&
          subscriptionGroup.map((group, index) => (
            <div key={index}>
              <div className="item-type--head">{group.groupName}</div>
              {group.userSubscriptions &&
                group.userSubscriptions.length > 0 &&
                group.userSubscriptions.map((userSubscription) => (
                  <div className="item">
                    <div className="item-values">
                      <div className="flex items-center mb-4">
                        <BaseSwitch
                          className="mr-2"
                          disabled={false}
                          isOn={userSubscription.subscription}
                          handleToggle={() => {
                            // Create a new object with the updated subscription property
                            
                            const updatedUserSubscription = {
                              ...userSubscription,
                              subscription: !userSubscription.subscription,
                            };

                            dispatch(
                              SubscriptionGroup({
                                subcriptionPostList: [updatedUserSubscription],
                              })
                            );
                          }}
                        />{" "}
                        {userSubscription.subCategory}
                        {/*/> {userSubscription.serviceCategory}*/}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ))
        ) : (
          <div className="load">
            <div className="load-placeholder">
              <div className="load-placeholder-text text-xl text-center mb-4">
                Please wait
              </div>
              <div className="load-placeholder-spinner">
                <LoadingSpinner size="lg" />
              </div>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default Subscriptions;
